import { signOut } from "aws-amplify/auth";
import { useNavigate } from "react-router-dom";
import { Btn, Card, Stack } from "./ui";

import "../css/AccountStatus.css";

//upgrade subscription handle the case where someone navigating from super admin to this page will need the return back button to send them to "/admin" but if they're not a super admin, just a normal admin with manage users permissions it will redirect them back to their user dashboard "/".

export const UpgradeSubscription = () => {
    const navigate = useNavigate();

    return (
        <div className="account-status-page">
            <Card variant="card-lg" cardClasses="card-pad-xl account-status-card">
                <Stack size="m">
                    <h1 className="account-status-title">Package Pricing</h1>
                    <p className="account-status-copy">Please request information about subscription tiers</p>
                    <h2 className="account-status-subtitle">Contact Info</h2>
                    <p className="account-status-copy">
                        Mark Stratton
                        <br />
                        Email: <a href="mailto:mstratton05@gmail.com">mstratton05@gmail.com</a>
                        <br />
                        Phone: <a href="tel:+14326613606">(432) 661-3606</a>
                    </p>
                    <div className="account-status-button">
                        <Btn variant="secondary-outlined" buttonText="Back" buttonOnClick={() => navigate("/", { replace: true })} />
                    </div>
                </Stack>
            </Card>
        </div>
    );
};

//Manage subscription is for links on the super admin dashboard where the navigation from the back button needs to return the user to the dashbaord "/" page 

export const ManageSubscription = () => {

    const navigate = useNavigate();

    return (
        <div className="account-status-page">
            <Card variant="card-lg" cardClasses="card-pad-xl account-status-card">
                <Stack size="m">
                    <h1 className="account-status-title">Package Pricing</h1>
                    <p className="account-status-copy">Request Information About Subscription Management Here!</p>
                    <h2 className="account-status-subtitle">Contact Info</h2>
                    <p className="account-status-copy">
                        Mark Stratton
                        <br />
                        Email: <a href="mailto:mstratton05@gmail.com">mstratton05@gmail.com</a>
                        <br />
                        Phone: <a href="tel:+14326613606">(432) 661-3606</a>
                    </p>
                    <div className="account-status-button">
                        <Btn variant="secondary-outlined" buttonText="Back" buttonOnClick={() => navigate("/", { replace: true })} />
                    </div>
                </Stack>
            </Card>
        </div>
    );
};

//this function handles the screen individuals are redirected to if they are found to have a correct cognito login but are no longer associated with any entry in Dynamo (ie a deleted CompanyOwner, or user from a deleted Company)
export const AccountStatus = () => {
    const navigate = useNavigate();

    const handleExit = () => {
        void (async () => {
            await signOut();
            navigate('/signup', { replace: true });
        })();
    };

    return (
        <div className="account-status-page">
            <Card variant="card-lg" cardClasses="card-pad-xl account-status-card">
                <h1 className="account-status-title">Account Not Found</h1>
                <p className="account-status-copy">
                    Please reach out to Mark Stratton if this is found in error or to create a new account.
                </p>
                <h2 className="account-status-subtitle">Contact Info</h2>
                <p className="account-status-copy">
                    Mark Stratton
                    <br />
                    Email: <a href="mailto:mstratton05@gmail.com">mstratton05@gmail.com</a>
                    <br />
                    Phone: <a href="tel:+14326613606">(432) 661-3606</a>
                </p>
                <div className="account-status-button">
                    <Btn variant="secondary-outlined" buttonText="Exit" buttonOnClick={handleExit} />
                </div>
            </Card>
        </div>
    );
};
